export default "__VITE_ASSET__CbsV8moI__"